import SettingsTabBase from "./SettingsTabBase.jsx";
import { SETTING_TAB_WIDGET_KEYS } from "../../../other/constants/OtherKeys.jsx";
import { userPreferences } from "../../../react/context/bryntumContext.jsx";
import { MessageDialog } from "@bryntum/schedulerpro";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";

export default class SettingsCanEditViewPrefTab extends SettingsTabBase {
  static get $name() {
    return "SettingsCanEditViewPrefTab";
  }

  static get type() {
    return "settingscaneditviewpreftab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.boardCanEditViewPrefTab;
  }

  static get configurable() {
    return {
      title: "Board",
      cls: "p-[1em]",
      defaults: {
        cls: "flex-[1_0_100%] @md:flex-[1_0_50%]",
        labelWidth: "10em"
      },
      items: {
        canEditField: {
          name: PERSISTENCE_STATE_KEYS.userDefaultEditPermission,
          text: "Can Edit",
          label: "Can Edit",
          type: 'combo',
          displayField: "name",
          valueField: "grantId",
          onChange: "up.onChangeCanEditViewPref",
        },
        canViewField: {
          name: PERSISTENCE_STATE_KEYS.userDefaultViewPermission,
          text: "Can View",
          label: "Can View",
          type: 'combo',
          displayField: "name",
          valueField: "grantId",
          onChange: "up.onChangeCanEditViewPref",
        }
      }
    };
  }


  getPickerItemsDisabled(record) {
    if (!this.context.user.can(record.grantId)) {
      record.cls = 'swivu-bryntum-combo-picker-disabled'
      return false;
    }
    return true;
  }

  setDefaultCanEditViewPref(key, role) {
    userPreferences.updateSetting(key, role);
    return role;
  }

  onChangeCanEditViewPref({ source, userAction }) {
    const {canViewField, canEditField } = this.widgetMap;
    if (userAction) {
      switch (source.name) {
        case PERSISTENCE_STATE_KEYS.userDefaultEditPermission: {
          if (source.value > userPreferences.getSetting(PERSISTENCE_STATE_KEYS.userDefaultViewPermission)) {
            canViewField.value = this.setDefaultCanEditViewPref(PERSISTENCE_STATE_KEYS.userDefaultViewPermission, source.value);
          }
          canEditField.value = this.setDefaultCanEditViewPref(PERSISTENCE_STATE_KEYS.userDefaultEditPermission, source.value);
          break;
        }
        case PERSISTENCE_STATE_KEYS.userDefaultViewPermission: {
          return canViewField.value = this.setDefaultCanEditViewPref(PERSISTENCE_STATE_KEYS.userDefaultViewPermission, source.value);
        }
        default:
      }
    }
  }

  loadRecord(record, context) {
    super.loadRecord(record, context);
    this.context = context;

    let { canEditField, canViewField } = this.widgetMap;

    this.swivuAppRoles = context.boardManager.boardNameStore.appRoles.filter((role) => role.grants.length);
    this.swivuAppRoles = this.swivuAppRoles.map((roleRecord) => ({ name: roleRecord.name, grantId: this.getGrantForRole(roleRecord) }));

    canEditField.items = this.swivuAppRoles;
    canViewField.items = this.swivuAppRoles;

    const boardUserRecord = context.project.boardUsersStore.records.find((user) => user.userId === context.user.id)
    const currentBoardUserGrant = this.getGrantForRole(boardUserRecord);
    const isEditOnPref = userPreferences.getSetting(PERSISTENCE_STATE_KEYS.userDefaultEditPermission);
    const isViewOnPref = userPreferences.getSetting(PERSISTENCE_STATE_KEYS.userDefaultViewPermission);

    canEditField.value = isEditOnPref || this.setDefaultCanEditViewPref(PERSISTENCE_STATE_KEYS.userDefaultEditPermission, currentBoardUserGrant);
    canViewField.value = isViewOnPref || this.setDefaultCanEditViewPref(PERSISTENCE_STATE_KEYS.userDefaultViewPermission, currentBoardUserGrant);

    canEditField.picker.isSelectable =  this.getPickerItemsDisabled.bind(this);
    canViewField.picker.isSelectable =  this.getPickerItemsDisabled.bind(this);
    canViewField.picker.on("beforeItem", this.onBeforePickerItemSelect.bind(this), this);
  }

  getGrantForRole(roleRecord) {
    return Math.min.apply(Math, roleRecord.grants.map((g) => g.value));
  }

  onBeforePickerItemSelect({ record }) {
    const { canViewField } = this.widgetMap;
    if (record.grantId < userPreferences.getSetting(PERSISTENCE_STATE_KEYS.userDefaultEditPermission)) {
      MessageDialog.alert({
        title: "Error",
        message: "View permission cannot be higher than Edit permission"
      });
      canViewField.hidePicker();
      return false;
    }
  }
}

SettingsCanEditViewPrefTab.initClass();
